<template>
    <i v-html="getIcon(level)"></i>
</template>

<script>
    export default {
        props: [ 'level', 'type' ],
        data () {
            return {

            }
        },
        methods: {
            getIcon (level) {
                if (!this.type) {
                    if (!level) level = 999
                    let icon = this.$alarms.find(x => x.id === level)
                    return "<i style='font-size: " + icon.size + "' class='" + icon.color + " " + icon.icon + "' title='" + icon.text + "'></i>"
                }
                else {
                    if (!level) level = 'Unknown'
                    let icon = this.$statuses.find(x => x.status === level)
                    return "<i style='font-size: 26px' class='" + icon.color + " fa fa-mobile' title='" + icon.text + "'></i>"
                }
            }
        }
    }
</script>

<style scoped>

</style>
